export function mergeCustomStyles(defaults: any = {}, overrides: any = {}): any {
  return { ...(defaults || {}), ...(overrides || {}) };
}

export function mergeMuiProps(defaults: any = {}, overrides: any = {}): any {
  return {
    ...(defaults || {}),
    ...(overrides || {}),
    sx: { ...(defaults?.sx || {}), ...(overrides?.sx || {}) },
  };
}

export default { mergeCustomStyles, mergeMuiProps };
